import { render, staticRenderFns } from "./PhonesEdit.vue?vue&type=template&id=1af58156&scoped=true"
import script from "./PhonesEdit.vue?vue&type=script&lang=js"
export * from "./PhonesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af58156",
  null
  
)

export default component.exports